import useAPI from "./useAPI";
// import useConfig from "../config";
function useBCStorefront() {
  const { API } = useAPI();
  // const { bigCommerceStoreHash } = useConfig();
  // const baseUrl = `https://api.bigcommerce.com/stores/${bigCommerceStoreHash}/v3`;
  const baseUrl = `/api/storefront`;
  const get = async (url, config) => {
    url = baseUrl + url;
    await API.get(url, config, true);
  };

  const del = async (url, config) => {
    url = baseUrl + url;
    await API.del(url, config, true);
  };

  return {
    BCStorefront: {
      get,
      del,
    },
  };
}

export default useBCStorefront;
